import React, { useEffect } from 'react';
import { type ViewStyle } from 'react-native';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming,
} from 'react-native-reanimated';

export const OrderPlaybackFadeInView = (
  props: OrderPlaybackFadeInViewProps,
) => {
  const { children, fadeIn, style } = props;
  const opacity = useSharedValue(0);

  useEffect(() => {
    opacity.value = withDelay(fadeIn, withTiming(1, { duration: 300 }));
  }, [fadeIn, opacity]);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }));

  return (
    <Animated.View style={[style, animatedStyle]}>{children}</Animated.View>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderPlaybackFadeInViewProps = {
  children: React.ReactNode;
  fadeIn: number;
  style?: ViewStyle;
};
